import { render, staticRenderFns } from "./PatientInsurances.vue?vue&type=template&id=8daba5ba&"
import script from "./PatientInsurances.vue?vue&type=script&lang=js&"
export * from "./PatientInsurances.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports